import {IServiceFamily} from "@/model/ServiceFamily/ServiceFamily"

export interface IHasServiceFamiliesSelected {
    getServiceFamiliesSelected(): IServiceFamily[]
    getServiceFamiliesMapSelected(): Map<string, IServiceFamily>
    addServiceFamilySelected(serviceFamily: IServiceFamily): void
    removeServiceFamilySelected(serviceFamily: IServiceFamily): void
}


function hasServiceFamilies<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServiceFamiliesSelected {
        private serviceFamiliesSelected: IServiceFamily[] = []
        private serviceFamiliesSelectedMap: Map<string, IServiceFamily> = new Map()
        
        constructor(...args: any[]) {
            super(...args);
        }

        public getServiceFamiliesSelected(): IServiceFamily[] {
            return this.serviceFamiliesSelected
        }
        public getServiceFamiliesMapSelected(): Map<string, IServiceFamily> {
            return this.serviceFamiliesSelectedMap
        }
        public addServiceFamilySelected(serviceFamily: IServiceFamily): void {
            if (this.serviceFamiliesSelectedMap.has(serviceFamily.getId())) return
            this.serviceFamiliesSelected.push(serviceFamily)
            this.serviceFamiliesSelectedMap.set(serviceFamily.getId(), serviceFamily)
        }
        public removeServiceFamilySelected(serviceFamily: IServiceFamily): void {
            if (!this.serviceFamiliesSelectedMap.has(serviceFamily.getId())) return
            this.serviceFamiliesSelected = this.serviceFamiliesSelected.filter((existingServiceFamily: IServiceFamily) => existingServiceFamily.getId() !== serviceFamily.getId())
            this.serviceFamiliesSelectedMap.delete(serviceFamily.getId())
        }

    };
}

export default hasServiceFamilies